import {Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {StringUtils} from "../services/string-utils";
import {flatMap, map, tap} from 'rxjs/operators';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-serving-join-servers',
  templateUrl:'./serving-join-servers.component.html',
})
export class ServingJoinServersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  canAddServingJoinServers: boolean;

  listServingJoinServers: any[];

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  public inputKeywordServingJoinServerSearch = "";
  public optionServingJoinServerSearch = "Search Type";

  public servingJoinServersRefreshing = false;

  configPagerServingJoinServers: PaginationInstance = {
    id: 'serving-join-servers-list',
    currentPage: 1,
    itemsPerPage: 5,
  };

  @Input() virtId: string;
  @Input() netIds: string[];
  @Input() name: string;
  @Input() protocolVersion: string;
  @Input() renderNsGroup: boolean;

  @Output() servingJoinServersLoadedEvent = new EventEmitter<any[]>();
  constructor(private route: ActivatedRoute,
              private router: Router,
              private http: HttpClient,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {
    this.isAdmin = this.userVerificationService.isAdmin;
  }

  editActivationAgreement(nsId, jsId, nsName, jsName, netIds, joinEuis) {
    this.router.navigate(['/edit-activation-agreement'], {
      queryParams: {
        nsId,
        jsId,
        nsName,
        jsName,
        netIds,
        joinEuis
      }
    });
  }

  createActivationAgreement(name, id, virtId, protocolVersion) {
    this.router.navigate(['./add-serving-join-server'], {queryParams: {name, id, virtId, protocolVersion}});
  }

  getAllJoinServersWithoutActivationAgreement(virtId){
    var url = ApiEndpoints.GET_ALL_JOIN_SERVERS_WOA;
    var body = {
      "virtID" : virtId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          this.canAddServingJoinServers = data.length != 0;
        }
      );
  }

  //get Serving Join Servers widget
  ServingJoinServers(id) {
    const headers = new HttpHeaders({
          'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    var body: any = {"virtId": id};
    var url = ApiEndpoints.GET_SERVING_JS_SERVERS;
    this.servingJoinServersRefreshing = true;
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listServingJoinServers = this.parseServingJoinServersList(data);
          this.servingJoinServersLoadedEvent.emit(this.listServingJoinServers);
          this.servingJoinServersRefreshing = false;
        }
      );
  }

  //Serving Join Servers search func
  ServingJoinServersSearch(vIdSearch, urlSearch, filterSearch, keywordSearch) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    if (filterSearch == "Name") {
      var body: any = {"virtId": vIdSearch, "name": keywordSearch};
      var url = urlSearch;
      this.servingJoinServersRefreshing = true;
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listServingJoinServers = this.parseServingJoinServersList(data)
            this.servingJoinServersLoadedEvent.emit(this.listServingJoinServers);
            this.servingJoinServersRefreshing = false;
          }
        );
    }
    if (filterSearch == "JoinEUI") {
      var body: any = {"virtId": vIdSearch, "joinEui": keywordSearch};
      var url = urlSearch;
      this.servingJoinServersRefreshing = true;
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listServingJoinServers = this.parseServingJoinServersList(data)
            this.servingJoinServersLoadedEvent.emit(this.listServingJoinServers);
            this.servingJoinServersRefreshing = false;
          }
        );
    }
    if (filterSearch == 'Search Type') {
      this.ServingJoinServers(this.virtId)
    }
  }

  refreshServingJoinServers() {
	  var urlSearch = ApiEndpoints.GET_SERVING_JS_SERVERS;
    this.ServingJoinServersSearch(this.virtId, urlSearch, this.optionServingJoinServerSearch, this.inputKeywordServingJoinServerSearch);
  }

  parseServingJoinServersList(listServingJoinServers) {
    listServingJoinServers.forEach(joinServer => {
      joinServer.joinEUIs = this.insertSpacesBetweenIds(joinServer.joinEUIs);
    });
    return listServingJoinServers;
  }

  insertSpacesBetweenIds(ids: Array<string>) {
    return StringUtils.insertSpacesBetweenIds(ids);
  }

  resetPager() {
      this.configPagerServingJoinServers.currentPage = 1;
  }

  onKeywordSearch(event: KeyboardEvent) {
    var urlSearch = ApiEndpoints.GET_SERVING_JS_SERVERS;
    if (event.keyCode === 13) {
      this.ServingJoinServersSearch(this.virtId, urlSearch, this.optionServingJoinServerSearch, this.inputKeywordServingJoinServerSearch);
    }
  }

  onOptionServingJoinServerSearchChanged(event) {
      const value = event.target.value;
      this.inputKeywordServingJoinServerSearch = "";
    }

  ngOnInit() {
    this.ServingJoinServers(this.virtId);
    this.getAllJoinServersWithoutActivationAgreement(this.virtId)

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1
    });
  }

  ngOnDestroy() {

  }
}
